import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "uv-tile-flags" }
const _hoisted_2 = {
  key: 0,
  class: "uv-tile-flag-condition"
}
const _hoisted_3 = {
  key: 1,
  class: "uv-tile-flag-onsale"
}
const _hoisted_4 = {
  key: 3,
  class: "uv-tile-flag-reserved"
}

import { computed } from 'vue';
	import { IVehicle } from '@/types';
	import { EStockCategoryId } from '@/enums';
	import VehicleFlagCertified from './VehicleFlagCertified.vue';

	
export default /*#__PURE__*/_defineComponent({
  props: {
    vehicle: null
  },
  emits: ['certifiedClick'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
		vehicle: IVehicle
	}

	

	

	const showCondition = computed(() => (window as any).uvShowConditionLabel);
	const v = computed(() => props.vehicle);
	const conditionText = computed((): string => {
		switch (props.vehicle.StockCategoryId){
			case EStockCategoryId.new: {
				return 'New';
			}
			case EStockCategoryId.used: {
				return (window as any).uvUsedCategoryLabel || '';
			}
			case EStockCategoryId.demo: {
				return 'Demo';
			}
			default: {
				return '';
			}
		}
	});

	const handleCertifiedClick = ($event: Event, v: IVehicle): void => {
		$event.preventDefault();
		emits('certifiedClick', v)
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showCondition))
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(conditionText)), 1))
      : _createCommentVNode("", true),
    (_unref(v).OnSale)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "On Sale"))
      : _createCommentVNode("", true),
    (_unref(v).IsToyotaCertifiedBool)
      ? (_openBlock(), _createBlock(VehicleFlagCertified, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(v).Reserved)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Reserved"))
      : _createCommentVNode("", true)
  ]))
}
}

})